import { Injectable } from '@angular/core';
import { ApplicationTranslation } from '@app/modules/management/pages/translations/interfaces/application-translation.interface';
import { TranslationResponseDTO } from '@app/modules/management/pages/translations/interfaces/translations-response-dto.interface';

@Injectable()
export class TranslationsFormatter {
  run(literals: TranslationResponseDTO[]): ApplicationTranslation {
    const translations = literals.reduce(
      (acc: ApplicationTranslation, curr) => {
        const key = curr.frontendLiteralsLabels.label;
        if (!(key in acc)) {
          acc[key] = curr.literal;
        }

        return acc;
      },
      {},
    );

    return translations;
  }
}
